export function generateInitials(name: string): string {
  const words = name.trim().split(' ')
  if (words.length === 0) return ''
  const firstNameInitial = words[0].charAt(0).toUpperCase()
  const lastNameInitial =
    words.length > 1 ? words[words.length - 1].charAt(0).toUpperCase() : ''
  return `${firstNameInitial}${lastNameInitial}`
}
